// extracted by mini-css-extract-plugin
export default {"tabWrapper":"tabs_tabWrapper__9ygxp","tabs":"tabs_tabs__CC23q","tab":"tabs_tab__8rs80","activeTab":"tabs_activeTab__BpjKd","tabDivider":"tabs_tabDivider__+3F6E"};